import api from '../axiosConfig';

const API_URL = '/api/users'; 

export const fetchUsers = () => api.get(API_URL);
export const createUser = (data) => api.post(API_URL, data);
export const updateUser = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deleteUser = (id) => api.delete(`${API_URL}/${id}`);
